import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import ServiceDetailLayout from "./ServiceDetailLayout";
import FaqItem from "./FaqItem";

const snapshot = {
  price: "a partir de 500 000 FCFA",
  delay: "4 a 8 semaines",
  idealFor: "Livraison, reservations, marketplaces, plateformes internes",
};

const sections = [
  { id: "intro", label: "Ce qu'on fait" },
  { id: "pour-qui", label: "Pour qui ?" },
  { id: "fonctionnalites", label: "Ce qu'on inclut" },
  { id: "process", label: "Notre methode" },
  { id: "faq", label: "FAQ" },
];

export default function MobileDetail() {
  return (
    <>
      <Helmet>
        <title>Applications Mobiles iOS & Android — NEXUS SOLUTIONS</title>
        <meta name="description" content="Developpement d'applications mobiles React Native pour iOS et Android. Orange Money, Wave, notifications push. A partir de 500 000 FCFA. Abidjan, Cote d'Ivoire." />
        <meta property="og:title" content="Applications Mobiles — NEXUS SOLUTIONS" />
        <meta property="og:description" content="Apps iOS et Android sur mesure pour le marche ivoirien. Paiement mobile money integre, livraison 4 a 8 semaines." />
      </Helmet>

      <ServiceDetailLayout title="Applications Mobiles" summarySections={sections} snapshot={snapshot}>

        <section id="intro">
          <h2>Ce qu'on fait</h2>
          <p>
            Nous developpons des applications mobiles iOS et Android sur mesure pour
            les entreprises ivoiriennes. On utilise <strong>React Native</strong> ce
            qui nous permet de livrer une seule application qui fonctionne sur les
            deux plateformes — moins de cout, meme qualite.
          </p>
          <p>
            Une application simple (catalogue, prise de rendez-vous, livraison) est
            livree en <strong>4 a 8 semaines</strong>. On vous accompagne aussi sur
            la publication dans l'App Store et le Google Play Store.
          </p>
        </section>

        <section id="pour-qui">
          <h2>Pour qui ?</h2>
          <p>Une app mobile a du sens quand vous voulez un canal direct avec vos clients ou digitaliser un processus metier.</p>
          <div className="for-who-grid">
            <div className="for-who-card">
              <span className="for-who-card__emoji">🛵</span>
              <div className="for-who-card__label">Services de livraison</div>
            </div>
            <div className="for-who-card">
              <span className="for-who-card__emoji">📅</span>
              <div className="for-who-card__label">Prise de rendez-vous</div>
            </div>
            <div className="for-who-card">
              <span className="for-who-card__emoji">🛒</span>
              <div className="for-who-card__label">Marketplaces locales</div>
            </div>
            <div className="for-who-card">
              <span className="for-who-card__emoji">🏦</span>
              <div className="for-who-card__label">Fintech & mobile money</div>
            </div>
            <div className="for-who-card">
              <span className="for-who-card__emoji">🎓</span>
              <div className="for-who-card__label">E-learning & formations</div>
            </div>
            <div className="for-who-card">
              <span className="for-who-card__emoji">🏢</span>
              <div className="for-who-card__label">Gestion interne PME</div>
            </div>
          </div>
        </section>

        <section id="fonctionnalites">
          <h2>Ce qu'on inclut</h2>
          <ul>
            <li>Application iOS + Android depuis un seul code source (React Native)</li>
            <li>Connexion et inscription utilisateurs</li>
            <li>Notifications push</li>
            <li>Integration de paiement (Orange Money, Wave, carte bancaire)</li>
            <li>Mode hors-ligne pour les fonctions essentielles</li>
            <li>Tableau de bord admin pour gerer le contenu de l'app</li>
            <li>Publication sur l'App Store et Google Play incluse</li>
          </ul>
        </section>

        <section id="process">
          <h2>Notre methode</h2>
          <ol>
            <li><strong>Cadrage</strong> — On definit ensemble les ecrans et les fonctions prioritaires. On part de l'essentiel.</li>
            <li><strong>Prototypage</strong> — On vous montre les maquettes de chaque ecran avant de coder.</li>
            <li><strong>Developpement</strong> — Livraison par etapes avec tests sur vrai telephone Android et iOS.</li>
            <li><strong>Publication</strong> — On s'occupe de la mise en ligne sur les stores et on forme votre equipe.</li>
          </ol>
        </section>

        <section id="faq">
          <h2>FAQ</h2>
          <FaqItem question="Combien ca coute ?">
            Une application simple demarre a partir de 500 000 FCFA. Le prix depend du nombre d'ecrans et des integrations (paiement, GPS, etc.). On commence toujours par un devis detaille. Consultez aussi nos <Link to="/tarifs" style={{ color: '#4b004b' }}>formules et tarifs</Link>.
          </FaqItem>
          <FaqItem question="Mon app sera disponible sur iPhone ET Android ?">
            Oui. React Native produit une vraie application native pour les deux plateformes depuis le meme code. Vous ne payez qu'une seule fois le developpement.
          </FaqItem>
          <FaqItem question="On peut commencer avec moins de fonctionnalites et ajouter ensuite ?">
            C'est meme conseille. On vous recommande de lancer une version simple (MVP) pour tester le marche, puis d'ajouter des fonctions selon les retours utilisateurs.
          </FaqItem>
          <FaqItem question="Que se passe-t-il apres la livraison ?">
            On reste disponibles pour les corrections, mises a jour et nouvelles fonctions. On prend en charge les mises a jour iOS/Android et les eventuels rejets lors de la soumission sur les stores.
          </FaqItem>
          <FaqItem question="Combien de temps faut-il pour publier sur les stores ?">
            Google Play valide generalement en 2 a 3 jours. L'App Store d'Apple peut prendre 5 a 7 jours. On gere l'ensemble du processus de soumission.
          </FaqItem>

          <div style={{ marginTop: '2rem', textAlign: 'center' }}>
            <Link
              to="/devis"
              style={{
                background: '#4b004b', color: '#fff', padding: '13px 36px',
                borderRadius: '28px', fontWeight: 700, textDecoration: 'none',
                fontSize: '1rem', display: 'inline-block',
              }}
            >
              Demander un devis gratuit
            </Link>
          </div>
        </section>

        <div className="related-services">
          <div className="related-services__title">Vous pourriez aussi avoir besoin de</div>
          <div className="related-services__grid">
            <Link to="/services/developpement-web" className="related-service-card">
              <span className="related-service-card__icon">🌐</span>
              <div className="related-service-card__body">
                <div className="related-service-card__title">Site Web</div>
                <div className="related-service-card__desc">Vitrine, landing page, app web</div>
              </div>
              <span className="related-service-card__arrow">→</span>
            </Link>
            <Link to="/services/applications-e-commerce" className="related-service-card">
              <span className="related-service-card__icon">🛒</span>
              <div className="related-service-card__body">
                <div className="related-service-card__title">E-commerce</div>
                <div className="related-service-card__desc">Orange Money & Wave integres</div>
              </div>
              <span className="related-service-card__arrow">→</span>
            </Link>
          </div>
        </div>

      </ServiceDetailLayout>
    </>
  );
}
